export default function StatsSection() {
  const stats = [
    { value: '5000万+', label: '累计用户', icon: 'ri-user-line' },
    { value: '100万+', label: '视频总量', icon: 'ri-video-line' },
    { value: '9+', label: '内容分类', icon: 'ri-grid-line' },
    { value: '99.9%', label: '服务可用率', icon: 'ri-server-line' },
  ];

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-primary-500">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-2">
            蘑菇视频数据一览
          </h2>
          <p className="text-sm text-white/75">我们用数据说话，用心服务每一位用户</p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-white/15 text-white">
                <i className={`${stat.icon} text-xl`}></i>
              </div>
              <div className="font-label text-2xl md:text-3xl font-bold text-white mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-white/70">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}